// extracted by mini-css-extract-plugin
module.exports = {"tipBox":"antd-pro-components-i-know-index-tipBox","tipText":"antd-pro-components-i-know-index-tipText","know":"antd-pro-components-i-know-index-know"};